import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { InvoiceTaxDocumentConsumerService, NotaFiscalConsumidorCancelamentoRequest } from 'src/app/services/invoice-tax-document-consumer.service';
import { ToastService } from 'src/app/services/toast.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'app-invoice-tax-consumer-cancel-dialog',
    templateUrl: './invoice-tax-consumer-cancel-dialog.component.html',
    styleUrls: ['./invoice-tax-consumer-cancel-dialog.component.scss']
})
export class InvoiceTaxConsumerCancelDialogComponent implements OnInit {

    form: UntypedFormGroup;
    invoiceId: number;
    loading = false;

    constructor(
        private fb: UntypedFormBuilder,
        private dialogRef: DynamicDialogRef,
        private config: DynamicDialogConfig,
        private invoiceTaxDocumentConsumerService: InvoiceTaxDocumentConsumerService,
        private toastService: ToastService,
        private spinner: NgxSpinnerService
    ) {
        this.invoiceId = this.config.data.invoiceId;
    }

    ngOnInit(): void {
        this.initForm();
    }

    private initForm(): void {
        this.form = this.fb.group({
            justificativa: ['', [Validators.required, Validators.minLength(15)]]
        });
    }

    async cancelar(): Promise<void> {
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            return;
        }

        this.loading = true;
        this.spinner.show();

        const request: NotaFiscalConsumidorCancelamentoRequest = {
            justificativa: this.form.get('justificativa')?.value
        };

        try {
            this.invoiceTaxDocumentConsumerService.cancelar(this.invoiceId, request).subscribe({
                next: (response) => {
                    // Verifica se o cancelamento foi bem-sucedido
                    if (response.status === 'cancelado' && response.status_sefaz === '135') {
                        const successMessage = `Nota fiscal cancelada com sucesso!\n${response.mensagem_sefaz}`;
                        this.toastService.success(successMessage);
                        this.dialogRef.close({ success: true });
                    } else {
                        // Se não foi cancelado com sucesso, trata como erro
                        const errorMessage = response.mensagem_sefaz || 'Erro ao cancelar nota fiscal';
                        this.toastService.error(errorMessage);
                    }
                },
                error: (error: HttpErrorResponse) => {
                    console.error('Erro ao cancelar nota fiscal:', error);
                    let errorMessage = 'Erro ao cancelar nota fiscal. Tente novamente.';

                    if (error.error && error.error.message) {
                        errorMessage = error.error.message;
                    } else if (error.message) {
                        errorMessage = error.message;
                    }

                    this.toastService.error(errorMessage);
                    this.loading = false;
                    this.spinner.hide();
                },
                complete: () => {
                    this.loading = false;
                    this.spinner.hide();
                }
            });
        } catch (error) {
            console.error('Erro ao cancelar nota fiscal:', error);
            this.toastService.error('Erro ao cancelar nota fiscal. Tente novamente.');
            this.loading = false;
            this.spinner.hide();
        }
    }

    cancelarDialog(): void {
        this.dialogRef.close();
    }
}
